import { rest } from 'msw';
import { API_REST_URL } from 'config/variables';

const getMyPoints = rest.get(
  `${API_REST_URL}/gamification-transactions/my-points/:clientId/:userId`,
  (req, res, ctx) => {
    return res(
      ctx.json({
        data: {
          availablePoints: 12570,
          user_id: 'user-1',
        },
        status: 'success',
      }),
    );
  },
);

export const gamificationHandlers = [getMyPoints];
